import { render, staticRenderFns } from "./PlanPart.vue?vue&type=template&id=6b5d40c2&scoped=true&"
import script from "./PlanPart.vue?vue&type=script&lang=js&"
export * from "./PlanPart.vue?vue&type=script&lang=js&"
import style0 from "./PlanPart.vue?vue&type=style&index=0&id=6b5d40c2&scoped=true&lang=css&"
import style1 from "./PlanPart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5d40c2",
  null
  
)

export default component.exports